"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exclusiveReducer = void 0;
var ExclusiveAction_1 = require("@/pages/exclusive/actions/ExclusiveAction");
var ExclusiveState_init_1 = require("@/pages/exclusive/states/ExclusiveState.init");
var typesafe_actions_1 = require("typesafe-actions");
exports.exclusiveReducer = function (state, action) {
    if (state === void 0) { state = ExclusiveState_init_1.defaultExclusiveState; }
    switch (action.type) {
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setPriceDropdownActive): {
            return __assign(__assign({}, state), { searchPriceDropdownActive: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setTypeDropdownActive): {
            return __assign(__assign({}, state), { searchTypeDropdownActive: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSearchPriceMin): {
            return __assign(__assign({}, state), { searchPriceMin: Number(action.payload) });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSearchPriceMax): {
            return __assign(__assign({}, state), { searchPriceMax: Number(action.payload) });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSearchType): {
            return __assign(__assign({}, state), { searchType: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSearchKeyword): {
            return __assign(__assign({}, state), { searchKeyword: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSearchSuggestion): {
            var suggestion = action.payload;
            return __assign(__assign({}, state), { searchKeyword: suggestion.name, searchResultId: suggestion.id, searchResultType: suggestion.type });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setTotalPage): {
            return __assign(__assign({}, state), { resultTotalPage: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setCurrentPage): {
            return __assign(__assign({}, state), { resultCurrentPage: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setProperties): {
            return __assign(__assign({}, state), { properties: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setRelatedProperties): {
            return __assign(__assign({}, state), { relatedProperties: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setLoading): {
            return __assign(__assign({}, state), { resultIsLoading: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSuggestionGroups): {
            return __assign(__assign({}, state), { searchSuggestionGroups: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSuggestionActive): {
            return __assign(__assign({}, state), { searchSuggestionsActive: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSuggestionIsLoading): {
            return __assign(__assign({}, state), { searchIsLoading: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSuggestionSelectedIndex): {
            return __assign(__assign({}, state), { searchSuggestionGroupSelectedIndex: action.payload.groupIndex, searchSuggestionSelectedIndex: action.payload.rowIndex });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setSearchSortBy): {
            return __assign(__assign({}, state), { searchSortBy: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setHasScrolled): {
            return __assign(__assign({}, state), { hasScrolled: action.payload });
        }
        case typesafe_actions_1.getType(ExclusiveAction_1.default.setPriceUnit): {
            return __assign(__assign({}, state), { searchPriceUnitIsMillion: action.payload });
        }
    }
    return state;
};
